import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["button"]
  static values = {
    url: String,
    page: { type: Number, default: 2 }
  }

  connect() {
    this.abortController = new AbortController()
  }

  disconnect() {
    this.abortController?.abort()
  }

  async loadMore(event) {
    event.preventDefault()

    const button = this.buttonTarget
    const originalText = button.textContent

    button.textContent = "Chargement..."
    button.disabled = true

    try {
      const response = await fetch(`${this.urlValue}?page=${this.pageValue}`, {
        method: "GET",
        headers: { "Accept": "text/vnd.turbo-stream.html" },
        signal: this.abortController.signal
      })

      if (!response.ok) throw new Error("Network response was not ok")

      const html = await response.text()
      Turbo.renderStreamMessage(html)
      this.pageValue++
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Error loading more articles:", error)
        button.textContent = originalText
        button.disabled = false
      }
    }
  }
}